import dom from '../../../wrapper/DomWrapper';

export default () => {
  const elHeader = dom.getElement('.header_fixed-wrapper');

  if (!elHeader) return 0;

  return dom.getElementHeight(elHeader);
};
